export default __webpack_public_path__ + "static/media/StimulationOff.7cff1a45.svg";